<template>
  <div
    class="sn-text"
  >
    <v-text-field
      :id="snInputProps_identifier"
      v-model="response"
      v-mask="snInputProps_mask"
      hide-details="auto"
      :data-cy="dataCy ? dataCy : 'password-field'"
      :autocapitalize="autocapitalize"
      :autofocus="snInputProps_autofocus"
      :class="snInputProps_classes"
      :error-messages="snInputProps_errorMessages"
      :placeholder="snInputProps_disabled ? null : snInputProps_placeholder"
      :hint="snInputProps_hint"
      :persistent-hint="!!snInputProps_hint ? true : null"
      :name="snInputProps_name"
      :required="snInputProps_required"
      :disabled="snInputProps_disabled"
      :aria-label="snInputProps_label"
      :maxlength="snInputProps_maxLength <= 0 ? undefined : snInputProps_maxLength"
      :min="snInputProps_min"
      :max="snInputProps_max"
      :type="show ? 'text' : 'password'"
      :inputmode="snInputProps_inputMode"
      :pattern="snInputProps_pattern"
      :prepend-inner-icon="snInputProps_innerIcon"
      :rules="snInputProps_rules"
      :autocomplete="autocomplete"
      :validate-on-blur="snInputProps_validateOnBlur"
      :append-icon="show ? 'sn-icon-eye' : 'sn-icon-eye-slash'"
      @mouseup="$emit('mouseup', $event)"
      @keydown="$emit('keydown', $event)"
      @keyup="$emit('keyup', $event)"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
      @change="$emit('change', $event)"
      @click:append="show = !show"
    />
  </div>
</template>

<script>
import SnInputProps from '../props/SnInputProps'
import { cypressMixin } from '../mixins/cypressMixin'

export default {
  name: 'SnPassword',
  mixins: [cypressMixin],
  props: {
    ...SnInputProps,
    autocapitalize: {
      type: String,
      default: '',
      required: false
    },
    autocomplete: {
      type: String,
      default: 'nope',
      required: false
    },
    value: {
      type: [String, Number, Array],
      default: '',
      required: false
    }
  },
  data () {
    return {
      response: '',
      show: false
    }
  },
  watch: {
    value (newVal) {
      this.response = newVal
    },
    response (newVal) {
      this.$emit('input', this.response)
    }
  },
  created () {
    this.response = this.value
  }
}
</script>
<style lang="scss" scoped>
@import '~/components/snui/v2/mixins/vuetifyOverrideCss.scss';

.sn-text {
  @extend .v-text-field--sn_override;
}

::v-deep .v-text-field {
  padding-top: 0 !important;
}

::v-deep .error--text .v-input__slot {
  border-color: $sn-error !important;
  .v-input__append-inner .error--text {
    color: $sn-error !important;
    caret-color: $sn-error !important;
  }
}

</style>
